import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class HeadTitle extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        children: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content, children } = this.props;
        const subTitle = content.slice(1);
        const subTitleList = subTitle.map((item, index) => {
            return [
                <a key={index} href={item.url} target="_blank" rel="noreferrer">
                    {item.title}
                </a>,
                index === subTitle.length - 1 ? '' : '|',
            ];
        });

        return (
            <div className={`${styles.head_title} clearfix`}>
                <div className={styles.sub_title}>{subTitleList}</div>
                {children}
                <div className={styles.title}>
                    <a>{content[0].title}</a>
                </div>
            </div>
        );
    }
}

export default errorBoundary(HeadTitle);
